<template>
  <section :class="['section_base page', {'tall': fullHeight, 'short': isShort}]">
    <section-header
      :title="title"
      :description="description"
      :no-bottom-margin="noBottomMargin"
    >
      <template v-slot:right>
        <slot name="right"></slot>
      </template>
    </section-header>

    <div class="section_base--inner">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionPage",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    isShort: {
      type: Boolean,
      default: false
    },
    noBottomMargin: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
// See section.scss for section_base styles
</style>
